import { theme } from "../theme";

export const DigitalSignatureStyles = () => ({
  checkboxBox: {
    margin: '0 0 40px 0',
    position: 'relative',
    color: theme.palette.secondary.black,
    '& p': {
      fontSize: '1.25rem',
      overflowWrap: 'break-word',
    },
    '& .MuiFormHelperText-root': {
      textAlign: 'center',
      position: 'absolute',
      width: '100%',
      bottom: '-32px',
    },
    '& .MuiCheckbox-root': {
      color: theme.palette.secondary.black,
      backgroundColor: 'transparent'
    },
  },
  checkboxCtn: {
    margin: '32px 0 0',
    display: 'flex',
    flexDirection: 'row',
    padding: { xs: '0 16px', md: '0' },
    justifyContent: { xs: 'flex-start', md: 'space-evenly' },
    '& .MuiFormControlLabel-root': {
      '& .MuiFormControlLabel-label': {
        fontSize: '1.25rem',
      },
    },
  },
  checkbox: {
    '&.MuiCheckbox-root': {
      color: theme.palette.primary.main,
    },
  },
  inputBox: {
    color: theme.palette.secondary.black,
    '& .inputTitle': {
      margin: '0 0 32px 0',
    },
    '& p': {
      fontSize: '1.25rem',
    },
    '& .MuiFormHelperText-root': {
      margin: '0',
      padding: '0 8px',
      fontSize: '0.875rem',
      backgroundColor: theme.palette.primary.white,
      borderRadius: '4px',
      bottom: '-10px',
      left: '10px',
    },
  },
  buttonWrapper: {
    marginTop: '22px',
    width: '100%',
    '& .MuiButton-root': {
      width: '100%',
      height: '48px',
      backgroundColor: theme.palette.primary.black,
      color: theme.palette.primary.white,
      textTransform: 'capitalize',
      fontSize: '1.125rem',
      '&:disabled': {
        color: theme.palette.primary.white,
      },
      '&:hover': {
        color: theme.palette.primary.black,
      },
    },
  },
});
